/* Imports */
import { API_HELPER } from "@/helpers/api.js";

/* Exports */
export const BANNERS_SERVICE = {
    getActiveBanners
};

/* Consts*/
const API_ROOT_SERVICE = "banners";

/* Services */
function getActiveBanners()
{
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const queryParams = {
        pageSize: 1,
        pageNumber: 1,
        searchText: '',
        sorter: 'ascending',
        propertyName: 'position',
        active: true
    };

    const requestOptions = {
        method: 'GET',
    };

    return API_HELPER.apiCall(url, queryParams, requestOptions);
}
